"use client";
import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";

// import redWave from "../../../assets/images/red.jpeg";
import blueWave from "../../../assets/images/blue.jpg";
// import pinkWave from "../../../assets/images/pink.jpeg";
import purpleWave from "../../../assets/images/purple.jpeg";
import greenWave from "../../../assets/images/green.jpeg";

// const getUser = () => {
//   const userStr = localStorage.getItem("user");
//   try {
//     return JSON.parse(userStr);
//   } catch {
//     return null;
//   }
// };

const DashboardCards = () => {
  const [cardInfo, setCardInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const storedUser = localStorage.getItem("user");
        const parsedUser = storedUser ? JSON.parse(storedUser) : null;
        const username = parsedUser?.username || parsedUser?.email || "";

        const response = await axios.post(
          "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/credit_user",
          { username }
        );

        const body =
          response.data?.["body-json"]?.body || response.data?.body || {};
        const item = body?.Items?.[0];

        setCardInfo({
          whatsapp_balance: item?.whatsapp_balance || 0,
          whatsapp_button_balance: item?.whatsapp_button_balance || 0,
          api_balance: item?.api_balance || 0,
          total_balance: item?.total_balance || 0,
          date: item?.date || "Now",
          time: item?.time || "",
        });
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
        // Fallback data so it's not blank
        setCardInfo({
          whatsapp_balance: 0,
          whatsapp_button_balance: 0,
          api_balance: 0,
          total_balance: 0,
          date: "N/A",
          time: "",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const cardData = cardInfo
    ? [
      {
        title: "WAPP BALANCE",
        total: cardInfo.whatsapp_balance.toLocaleString(),
        wave: purpleWave,
        iconColor: "linear-gradient(to right, #a18cd1, #fbc2eb)",
      },
      {
        title: "WBTN BALANCE",
        total: cardInfo.whatsapp_button_balance.toLocaleString(),
        wave: greenWave,
        iconColor: "linear-gradient(to right, #38ef7d, #11998e)",
      },
      // {
      //   title: "API BALANCE",
      //   total: cardInfo.api_balance.toLocaleString(),
      //   wave: pinkWave,
      //   iconColor: "linear-gradient(to right, #ff758c, #ff7eb3)",
      // },
      // {
      //   title: "TOTAL BALANCE",
      //   total: cardInfo.total_balance.toLocaleString(),
      //   wave: redWave,
      //   iconColor: "linear-gradient(to right, #ff5e62, #ff9966)",
      // },
      {
        title: "LAST LOGIN",
        date: cardInfo.date,
        time: cardInfo.time,
        wave: blueWave,
        iconColor: "linear-gradient(to right, #36d1dc, #5b86e5)",
      },
    ]
    : [];

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "#e1f5fe",
        minHeight: "90vh",

        justifyContent: "center",
      }}
    >
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid
          container
          spacing={2}
          sx={{
            maxWidth: "100%",
            width: "100%",
            margin: "0 auto",
          }}
        >
          {cardData.map((card, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: 4,
                  boxShadow: 3,
                  height: 160,
                  width: "100%",
                  maxWidth: 300,
                  minWidth: 250,
                  px: 2,
                }}
              >
                <Box
                  component="img"
                  src={card.wave}
                  alt="wave"
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    top: 0,
                    left: 0,
                    zIndex: 0,
                    opacity: 0.3,
                  }}
                />

                <IconButton
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 14,
                    background: card.iconColor,
                    color: "white",
                    zIndex: 1,
                    width: 30,
                    height: 30,
                  }}
                >
                  <HomeIcon fontSize="small" />
                </IconButton>

                <IconButton
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    right: 16,
                    bgcolor: "black",
                    color: "white",
                    zIndex: 1,
                    width: 30,
                    height: 30,
                  }}
                >
                  <OpenInNewIcon fontSize="small" />
                </IconButton>

                <CardContent
                  sx={{
                    position: "relative",
                    zIndex: 1,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography fontWeight="bold" gutterBottom>
                    {card.title}
                  </Typography>
                  <Box>
                    {card.total && (
                      <Typography variant="h6" fontWeight="medium">
                        {card.total}
                      </Typography>
                    )}
                    {card.date && (
                      <Typography variant="body1">Date: {card.date}</Typography>
                    )}
                    {card.time && (
                      <Typography variant="body1">Time: {card.time}</Typography>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default DashboardCards;
